import { AlertPresenter } from '../AlertBinder';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { Logger } from '../support/Logger';
import { Auth0AuthService } from '../auth/AuthService';

export class AnonymousAcceptInviteAlert {
    static inject = () => [
        AlertPresenter,
        HistoryViewModel,
        Logger,
        Auth0AuthService
    ];
    constructor(
        private alert: AlertPresenter,
        private history: HistoryViewModel,
        private logger: Logger,
        private auth: Auth0AuthService
    ) {}
    show = async ({ patient }: { patient?: string; }) => {
        let message = 'To accept this invite, you will need to sign in.';
        if (patient){
            message = `To accept this invite to ${patient}'s Innerhive, you will need to sign in.`;
        }
        const action = await this.alert.showAlertV2({
            header: 'Login Required to Accept',
            message,
            wider: true,
            options: [{
                id: 'cancel',
                label: 'Decline',
                role: 'destructive'
            }, {
                id: 'continue',
                label: 'Sign In'
            }]
        });

        if (action === 'cancel'){
            this.history.push('/');
        }
        else if (action === 'continue'){
            this.logger.info(`redirecting to login so that anonymous user can accept invite`);
            await this.auth.login();
        }
    };
}
